import type { SectionAssignment } from '@breakoutlearning/firebase-repository/models/SectionAssignment'

type GradingScalars = SectionAssignment['data']['assignmentGradingScalars']

/**
 * True when the grading scalars differ by value. Turning grading on/off or
 * changing any weight counts as a change; key reordering does not.
 */
export function gradingScalarsChanged(
  before: GradingScalars,
  after: GradingScalars
): boolean {
  return JSON.stringify(before ?? null) !== JSON.stringify(after ?? null)
}
